// LIB
import React from 'react';
import styled from 'styled-components';

// STYLES
import { colors, fontSize, fontFamily } from '../../Design_System/DesignSystem';

// COMPONENTS
import { Text } from '../atoms/Text';

interface MenuProps {
  setSelectedItem: React.Dispatch<React.SetStateAction<number>>;
  selectedItem: number;
  menus: {
    number: string;
    name: string;
  }[];
  className?: string;
}

const Menu = ({
  setSelectedItem,
  selectedItem,
  menus,
  className,
}: MenuProps) => {
  const handleItemClick = (index: number) => {
    setSelectedItem(index);
  };

  return (
    <MenuList className={className}>
      {menus.map((item, index) => (
        <MenuItem
          key={index}
          onClick={() => handleItemClick(index)}
          selectedItem={selectedItem}
          index={index}
        >
          <Text
            color={colors.tan}
            fontSize={fontSize.medium}
            fontFamily={fontFamily.tinos}
            bold={false}
            justify={false}
          >
            {item.number}
          </Text>
          <span> </span>
          <Text
            color={colors.tan}
            fontSize={fontSize.medium}
            fontFamily={fontFamily.tinos}
            bold={false}
            justify={false}
          >
            {item.name}
          </Text>
        </MenuItem>
      ))}
    </MenuList>
  );
};

const MenuList = styled.ol`
  list-style: none;
  padding: 0;
`;
const MenuItem = styled.li<{ selectedItem: number; index: number }>`
  cursor: pointer;
  display: flex;

  margin-top: 14px;

  @media (min-width: 776px) {
    animation: fade-in 0.3s ease;
    position: relative;
    width: fit-content; // Ajout de la propriété width: fit-content
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      height: 1px;
      background-color: ${colors.tan};
      transform: scaleX(0);
      transform-origin: left center;
      transition: transform 0.3s ease;
    }
    &:hover::after,
    &:nth-child(${(props) => props.selectedItem + 1})::after {
      transform: scaleX(1);
      width: ${(props) =>
        props.selectedItem === props.index ? '100%' : 'calc(100%)'};
    }
  }
`;

export default Menu;
